import DefaultLayout from "@/layouts/DefaultLayout";
import { NextPage } from "next";
import { NextSeo } from "next-seo";
import { ProductKind } from "@/web-client/api";
import InfiniteScroll from "react-infinite-scroll-component";
import Circular from "@/components/Circular";
import ProductVariationItemList from "@/features/product_variation/components/ProductVariationItemList";
import ProductSearchGroup from "@/features/product/components/ProductSearchGroup";
import NavigationProductSidebar from "@/components/NavigationProductSidebar";
import NotFoundSearchView from "@/components/NotFoundSearchView";
import useExistCategories from "@/hooks/useExistCategories";
import useProductSearch from "@/features/product_variation/hooks/useProductSearch";
import usePageViewOnSearch from "@/hooks/usePageViewOnSearch";
import ProductVariationItem from "@/features/product_variation/components/ProductVariationItem";

const InteriorSearchPage: NextPage = () => {
  usePageViewOnSearch();

  const {
    categoryId,
    pagination: {
      data,
      dataLength,
      next,
      hasNext,
      notFound,
      totalCount,
      updateItem,
    },
    parameter: { query, queryController },
  } = useProductSearch(
    "/interiors/product_variations/search",
    ProductKind.INTERIOR,
  );
  const { existInteriorCategories } = useExistCategories();

  return (
    <DefaultLayout hiddenFooter={true}>
      <NextSeo
        title={`家具の検索結果`}
        description={`TECTURE内の家具を検索した結果`}
        noindex={true}
      />
      <ProductSearchGroup
        kind={ProductKind.INTERIOR}
        totalCount={totalCount}
        sidebar={
          <NavigationProductSidebar
            kind={ProductKind.INTERIOR}
            categories={existInteriorCategories}
            categoryId={categoryId}
            query={query}
            queryController={queryController}
          />
        }
        query={query}
        queryController={queryController}
        isSearchingPosts={false}
      >
        <InfiniteScroll
          style={{ overflow: "visible" }}
          dataLength={dataLength}
          next={next}
          hasMore={hasNext}
          loader={<Circular />}
        >
          <ProductVariationItemList
            productVariations={data}
            onRender={(variation) => (
              <ProductVariationItem
                productVariation={variation}
                mutate={(updated) => updateItem(updated, false)}
              />
            )}
          />
        </InfiniteScroll>
        {notFound && <NotFoundSearchView />}
      </ProductSearchGroup>
    </DefaultLayout>
  );
};

export default InteriorSearchPage;
